import { FormSubmitAction } from './BriefPage'

export const getSubmitAction = (
  formValues: any,
  generateBrief: FormSubmitAction,
  generateVariants: FormSubmitAction
): FormSubmitAction => {
  const submitAction = formValues?.submitAction

  switch (submitAction) {
    case 'formChangedWithTopics':
    case 'formChangedWithBrief':
    case 'generateBrief':
    case 'refreshBrief':
      return generateBrief
    case 'generateWithoutTopics':
    case 'formChangedWithoutTopics':
    case 'topicsChanged':
    case 'generateVariants':
    case 'brandVoiceChanged':
    case 'formChangedWithBriefFocusThemeOnly':
      return generateVariants
    default:
      return async () => {}
  }
}
